import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { LiveAgentFormPage } from "~/pages/LiveAgentFormPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents_/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, id } = Route.useParams();
  useBreadCrumbs([
    { title: "Settings", link: `/${datasetSlug}/settings/api` },
    { title: "Live Agents", link: `/${datasetSlug}/settings/live-agents` },
    { title: "Edit", link: `/${datasetSlug}/settings/live-agents/${id}/edit` },
  ]);
  return <LiveAgentFormPage liveAgentId={id} />;
}
